import gql from 'graphql-tag';

export default gql`
  mutation addSectionContent($sectionContent: SectionContentInput!) {
    addSectionContent(sectionContent: $sectionContent) {
      _id
    }
  }
`;
